import * as React from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Sidebar from './Sidebar';
// import AppBar from './TopBar';
import TopBar from './TopBar';
import { styled } from '@mui/material/styles';
import { Outlet } from 'react-router-dom';

const sideBarMenu = ['Dashboard', 'Live Tracking', 'Access control', 'Users / Customer', 'Drivers', 'Sales Report', 'Categories', 'Brands', 'Items', 'Item Attribute', 'Orders', 'Coupons', 'Notifications', 'Payments', 'Banner Items', 'Email Templates', 'CMS Pages', 'Settings'];

export default function DashboardLayout() {
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [lan, setLan] = React.useState('');
  const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  }));

  const handleDrawerToggle = () => setOpen((prev) => !prev);
  const handleProfileMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMobileMenuOpen = (event) => setMobileMoreAnchorEl(event.currentTarget);
  const handleChange = (event) => setLan(event.target.value);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <TopBar
        open={open}
        handleDrawerToggle={handleDrawerToggle}
        lan={lan}
        handleChange={handleChange}
        handleProfileMenuOpen={handleProfileMenuOpen}
        handleMobileMenuOpen={handleMobileMenuOpen}
        isMenuOpen={isMenuOpen}
        isMobileMenuOpen={isMobileMenuOpen}
        anchorEl={anchorEl}
        mobileMoreAnchorEl={mobileMoreAnchorEl}
      />
      <Sidebar open={open} sideBarMenu={sideBarMenu} />

      <Box
      className='main-con-cls'
        component="main"
        sx={{
          flexGrow: 1,
          p: 0,
        }}
      >
        {/* Render the content from Home or other components here */}
        <Outlet />
      </Box>
    </Box>
  );
}
